/**
 * Skeleton shown while a lazily-loaded route chunk downloads. Sized
 * to match the typical authed page (sticky page header + grid below)
 * so the layout doesn't jump when the real component renders.
 */
import { Skeleton } from '@/components/ui/skeleton';

export function RouteFallback() {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-72" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
      <Skeleton className="h-72 w-full" />
    </div>
  );
}
